// Deferred-cost read allowlist (EXT-LAUNCH-009 / DEC-OPEN-006). Must mirror the backend
// Role.canSeeDeferredCost() allowlist exactly.
//   - INTERNAL_PM / INTERNAL_ADMIN: full visibility.
//   - EXTERNAL_SUBCONTRACTOR_PM: only their own company's deficiencies (row scoping is enforced
//     server-side; the server redacts deferredCost on anything they shouldn't see).
// Excluded: INTERNAL_SUPER, INTERNAL_TRADE, EXTERNAL_SUBCONTRACTOR_TRADE, EXTERNAL_CONSULTANT.
// EXTERNAL_OWNER is excluded for now (not in the current external rollout); revisit before owner launch.
const DEFERRED_COST_ROLES = new Set(['INTERNAL_PM', 'INTERNAL_ADMIN', 'EXTERNAL_SUBCONTRACTOR_PM']);

const INTERNAL_MANAGER_ROLES = new Set(['INTERNAL_PM', 'INTERNAL_SUPER', 'INTERNAL_ADMIN']);

const EXTERNAL_OWNER_CONSULTANT_ROLES = new Set(['EXTERNAL_OWNER', 'EXTERNAL_CONSULTANT']);

export const isExternalRole = (role) => role?.startsWith('EXTERNAL_') || false;

export const isExternalSubcontractorRole = (role) =>
    role?.startsWith('EXTERNAL_SUBCONTRACTOR_') || false;

export const isInternalManagerRole = (role) => INTERNAL_MANAGER_ROLES.has(role);

export const isDeficiencyWorkRole = (role) =>
    role === 'INTERNAL_TRADE' || isExternalSubcontractorRole(role);

export const isExternalOwnerConsultantRole = (role) => EXTERNAL_OWNER_CONSULTANT_ROLES.has(role);

export const canSeeCompanyFilter = (role) => !isExternalSubcontractorRole(role);

export const canSeeInternalOnlyFilter = (role) => !isExternalRole(role);

export const canSeeDeferredCost = (role) => DEFERRED_COST_ROLES.has(role);

const TRADE_ROLES = new Set(['INTERNAL_TRADE', 'EXTERNAL_SUBCONTRACTOR_TRADE']);

export const isTradeRole = (role) => TRADE_ROLES.has(role);
